module.exports = __webpack_public_path__ + "static/img/banner-web.f028b3e7.jpg";